module.exports = __webpack_public_path__ + "static/media/Hero_Story_Tablet.a29ea3a1.jpg";